<div class="flex flex-col" *ngIf="env.SHOW_BANNERS && (banners$ | async)?.length">
    <rwidget-banner *ngFor="let banner of banners$ | async" [bannerMessage]="banner"></rwidget-banner>
</div>
<div [ngClass]="{ 'bg-[var(--color-primary)] dark:bg-contrast-black': this.env.APP_NAME === 'gotland' }">
    <div
        class="sr-app-light:bg-white vl-app-light:bg-white var-app-light:bg-white gl-light-dark:mb-0 mb-4 shadow dark:bg-black md:m-0">
        <div>
            <h1
                class="vl-app-light:font-bold orb-app-light-dark:font-bold mx-4 py-5 text-center text-base font-semibold">
                {{ 'JOURNEY_PLANNER_HEADER' | translate }}
            </h1>

            <div class="relative mx-4" *ngIf="this.env.APP_NAME !== 'gotland'; else elseBlock">
                <p
                    class="vl-app-light:hidden absolute left-0 right-0 mx-4 my-6 text-center text-xl font-bold italic text-green-700"
                    *ngIf="!this.env.JOURNEY_PLANNER?.SHOW_FAVORITES">
                    {{ 'JOURNEY_PLANNER_INTRO_LABEL' | translate }}
                </p>
                <img
                    class="w-full rounded-2xl"
                    *ngIf="!this.env.JOURNEY_PLANNER?.SHOW_FAVORITES"
                    alt=""
                    src="{{ assetsPath$ | async }}/img/journey-planner/journey-planner-intro.jpg" />
            </div>
        </div>
        <ng-template #elseBlock>
            <div class="relative mx-4">
                <p
                    class="absolute left-0 right-0 mx-4 my-6 p-4 text-left text-3xl font-semibold tracking-normal text-[#1f497d]">
                    {{ 'JOURNEY_PLANNER_HELPER' | translate }}
                </p>
                <img
                    class="w-full rounded-2xl"
                    alt=""
                    src="{{ assetsPath$ | async }}/img/journey-planner/journey-planner-helper.svg" />
            </div>
        </ng-template>

        <rwidget-journey-planner-search
            class="gl-dark:bg-[var(--color-primary)] gl-dark:bg-contrast-black mt-6 block"></rwidget-journey-planner-search>
    </div>
    <div
        class="bg-white shadow"
        *ngIf="env.JOURNEY_PLANNER?.SHOW_SEARCH_HISTORY && (searchRecentlyJourneys$ | async)?.length > 0">
        <rwidget-search-recently-journeys></rwidget-search-recently-journeys>
    </div>

    <rwidget-journey-planner-favorite-list
        class="mt-4 block shadow"
        *ngIf="(favoriteStops$ | async)?.length && env.JOURNEY_PLANNER?.SHOW_FAVORITES"
        (clickOnLocation)="handleClickOnLocation($event)"></rwidget-journey-planner-favorite-list>
</div>
